export { default } from './FareItemMediumSize';
